import React from 'react';
import {clsx} from "clsx";

function ButtonLink({children, href, target, secondary, className, disabled}) {
    return (
        <a
            href={disabled ? '#' : href}
            target={target || '_self'}
            onClick={e => disabled && e.preventDefault()}
            className={clsx(
                secondary
                    ? 'from-red-500 to-orange-500 hover:from-red-400 hover:to-orange-400 hover:shadow-lg hover:shadow-red-200 border-b-2 border-red-700'
                    : 'from-green-500 to-blue-500 hover:from-green-400 hover:to-blue-400 hover:shadow-lg hover:shadow-blue-200 border-b-2 border-blue-700',
                'inline-flex items-center rounded-lg bg-gradient-to-br px-4 py-2 text-center text-sm font-semibold text-white shadow-md transform transition-all duration-200 ease-in-out hover:translate-y-[-2px] active:translate-y-[1px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500',
                className,
                disabled && 'bg-gradient-to-br from-gray-400 to-gray-600 border-gray-700 cursor-not-allowed hover:translate-y-0 hover:shadow-md'
            )}
        >
            {children}
        </a>
    );
}

export default ButtonLink;
